export enum ELoginActions {
    LOGIN = 'LOGIN'
}
